import React from "react";
import BannerImage from "./BannerImage";
import LeftImgRightText from "./LeftImgRightText";
import RightImgLeftText from "./RightImgLeftText";
import "../App.css";

const PasssGuard = () => {
  document.title = "PasssGuard";

  return (
    <div className="ui">
      <BannerImage
        title={"Save to safe"}
        image={require("../assets/img/pg/gg1.jpg")}
      />

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/pg/ss1.png")}
          text={"PasssGuard"}
          obj={{
            title: "Safe App",
            desc: "Remember 1 secret password for all your passwords",
            dl:
              "This application can function without internet and is storing your data on your local device only.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/passsguard/id1458491688",
            android:
              "https://play.google.com/store/apps/details?id=io.ionic.password",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/pg/ss2.png")}
          text={"PasssGuard"}
          obj={{
            title: "Multiple Functions",
            desc: "More than keep passwords, it keeps track your to do items",
            dl:
              "Manage your post it virtually in your phone and keep them within your fingertip.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/passsguard/id1458491688",
            android:
              "https://play.google.com/store/apps/details?id=io.ionic.password",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/pg/ss3.png")}
          text={"PasssGuard"}
          obj={{
            title: "Interactive and Intuitive",
            desc: "Add your newly created account and password",
            dl:
              "Remember that the secret key is the one and only key that you need to remember. Never tell it to anyone.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/passsguard/id1458491688",
            android:
              "https://play.google.com/store/apps/details?id=io.ionic.password",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/pg/ss4.png")}
          text={"PasssGuard"}
          obj={{
            title: "Track your to do items",
            desc:
              "Color coded to do items to enable you to manage your tasks more efficiently",
            dl:
              "3 status of the to do item - Not Started, In Progress and Completed. Save the Earth by reducing post it and update your to do items' status within your fingertip",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/passsguard/id1458491688",
            android:
              "https://play.google.com/store/apps/details?id=io.ionic.password",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/pg/ss5.png")}
          text={"PasssGuard"}
          obj={{
            title: "Priority | Status | Due Date",
            desc: "Every task needs a priority, status and due date",
            dl:
              "Give deadline for yourself so that things can start moving and you will stop procastinating. Prioritize your tasks and focus on high priority tasks first!",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/passsguard/id1458491688",
            android:
              "https://play.google.com/store/apps/details?id=io.ionic.password",
          }}
        />
      </div>
    </div>
  );
};

export default PasssGuard;
